import React from "react";
import { Typography } from "@genie-ui/react";
import { HighlighteText } from "@components";
import { Link } from "react-router-dom";
import { Constants } from "@constants";

const OptionItem = ({
  optionKey,
  optionLink,
  vendorName,
  productOrProfileName,
  type,
  optionValue,
  handleOptionClick,
  isOptionRouteable,
}) => {
  const { BY_WORD, PRODUCT_TYPE } = Constants.SEARCH;
  const content = (
    <Typography
      variant="body5"
      className="menu__list__item-text menu__list__item-product"
    >
      {productOrProfileName && type === PRODUCT_TYPE && (
        <>
          <HighlighteText text={productOrProfileName} highlight={optionValue} />
          {BY_WORD}
        </>
      )}
      <Typography
        className="menu__list__item-text  menu__list__item-product"
        variant="body1"
      >
        <HighlighteText text={vendorName} highlight={optionValue} />
      </Typography>
    </Typography>
  );

  return (
    <li className="menu__list__item optionItem" key={optionKey}>
      {isOptionRouteable ? (
        <Link
          to={optionLink}
          className="menu__list__item-link"
          onClick={handleOptionClick}
        >
          {content}
        </Link>
      ) : (
        <span
          className="menu__list__item-link"
          role="button"
          tabIndex={0}
          onClick={handleOptionClick}
        >
          {content}
        </span>
      )}
    </li>
  );
};

export default OptionItem;
